import React from 'react';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import { Tooltip } from '@mui/material';
import { buildQaId } from 'utils/build-qa-id';
import { IInterpreterService } from 'models/services/interpreter-service/IInterpreterService';
import { useStyles } from './need-interpreter-icon.styles';
import { ACCOUNT_NA, PIN_NA } from './constants';

const getQaId = buildQaId('need-interpreter-icon');

interface INeedInterpreterIconProps {
  languages?: { value: string; label?: string }[];
  interpreterServicePhoneNumbers?: IInterpreterService[];
  onClick?: () => void;
}

export const NeedInterpreterIcon: React.FC<INeedInterpreterIconProps> = (
  props: INeedInterpreterIconProps,
): JSX.Element => {
  const classes = useStyles();
  const [tooltipLines, setTooltipLines] = React.useState<(string | JSX.Element)[]>([]);

  React.useEffect(() => {
    const lines: (string | JSX.Element)[] = [];
    if (props.languages && props.languages.length > 0) {
      lines.push('Interpreter Needed:');
      props.languages
        .filter(({ value }) => value != null)
        .forEach(({ label, value }) => lines.push(label || value));
    } else {
      lines.push('Needs interpreter');
    }

    if (props.interpreterServicePhoneNumbers && props.interpreterServicePhoneNumbers.length > 0) {
      lines.push(
        <span key="click" style={{ textDecoration: 'underline', cursor: 'pointer' }}>
          Click for Interpreter numbers
        </span>,
      );
    }

    setTooltipLines(lines);
  }, [props.languages, props.interpreterServicePhoneNumbers]);

  const stop = (e: React.MouseEvent) => e.stopPropagation();

  const iconElement = (
    <span
      data-qa-id={getQaId('typography')}
      onMouseEnter={stop}
      onMouseLeave={stop}
      onClick={props.onClick}
    >
      <RecordVoiceOverRoundedIcon className={classes.icon} />
    </span>
  );

  const tooltipContent = (
    <span style={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}>
      {tooltipLines.map((l, idx) => (
        <React.Fragment key={idx}>
          {l}
          {idx < tooltipLines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </span>
  );

  return <Tooltip title={tooltipContent}>{iconElement}</Tooltip>;
};
